import { motion } from "motion/react";

import { IResPassengersSearchResult } from "@/types/tasks.types";

import GlobalSearchPassengerItem from "./GlobalSearchPassengerItem";

function GlobalSearchItemContent({
    items,
    highlightName,
    highlightFlightNumber,
}: {
    items: IResPassengersSearchResult[];
    highlightName?: string;
    highlightFlightNumber?: string;
}) {
    return items.map((item) => (
        <motion.div
            key={item.id}
            variants={{
                hidden: { opacity: 0, y: 20 },
                visible: {
                    opacity: 1,
                    y: 0,
                    transition: {
                        duration: 0.4,
                        ease: "easeOut",
                    },
                },
            }}
        >
            <GlobalSearchPassengerItem
                item={item}
                highlightName={highlightName}
                highlightFlightNumber={highlightFlightNumber}
            />
        </motion.div>
    ));
}

export default GlobalSearchItemContent;
